import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppOverlay } from "./Generic/AppOverlay";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const fadeOut = keyframes`
    from { opacity: 1; }
    to   { opacity: 0; }
`;

const fadeIn = keyframes`
    from { opacity: 0; }
    to   { opacity: 1; }
`;

const ChangesSavedBannerWrapper = styled.div`
  position: absolute;
  width: 100%;
  font-size: 15px;
  color: white;
  text-align: center;
  box-sizing: border-box;
  background: #1cb394;
  padding: 4px;
  z-index: 8000;
  top: 0;
  animation: ${fadeIn} 0.5s, ${fadeOut} 0.5s ease-in 1s;
  animation-fill-mode: forwards;
`;

const ChangesSavedBanner = (props: Props) => {
  React.useEffect(() => {
    const timeId = setTimeout(() => {
      props.onClose();
    }, 2000);

    return () => {
      clearTimeout(timeId);
    };
  }, [props]);

  if (!props.isOpen) {
    return null;
  }

  return (
    <AppOverlay>
      <ChangesSavedBannerWrapper>
        <span>{translate(STRINGS.CHANGES_WERE_SAVED_IN_THE_CLOUD)}</span>
      </ChangesSavedBannerWrapper>
    </AppOverlay>
  );
};

export default ChangesSavedBanner;
